<mat-chip class="m-1 tag"
          [ngStyle]="{'background-color': bgColor && bgColor, 'cursor': handleClick && 'pointer'}"
          [ngClass]="{'selected-tag': chipSelected}"
          
            (click)="toggleSelection()">
      <span >{{ text }}</span>
  <svg-icon src="/assets/icons/{{chipSelected ? 'close-circle-primary.svg' : 'plus-rounded-circle-primary.svg'}}"
  style="pointer-events: none;"
  matChipRemove></svg-icon>
  <!-- </button> -->
</mat-chip>
